import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PostCategoryService {
  constructor(private readonly http: HttpClient) {}
  getAllPostCategories(params: any): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('/v1/admin/post-category', { params });
  }

  getPostCategoryById(id: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`/v1/admin/post-category/${id}`);
  }

  editPostCategory(id: string, postCategoryData: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/post-category/${id}`, postCategoryData);
  }

  deletePostCategory(id: string): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`/v1/admin/post-category/${id}`);
  }

  createPostCategory(postCategoryData: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`/v1/admin/post-category`, postCategoryData);
  }

  changeSequence(data: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/post-category/updateSequence/`, { data });
  }
}
